import { ModelBase } from 'store/model-base';

export class CmsUserRoles extends ModelBase {
    public static storeName: string = 'cmsUserRoles';

    public header: string;
    public role: string;
    public description: string;
    public cbmDescription: string;
}
